import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
import { ConversationMessageModel } from '../models/conversations';
@Pipe({
  name: 'uniqueMessages',
})
export class UniqueMessagesPipe implements PipeTransform {
  transform(messages: ConversationMessageModel[]): ConversationMessageModel[] {
    if (messages !== undefined && messages !== null) {
      return _.uniqBy(messages, 'firebaseDocumentId');
    }
    return messages;
  }
}
